import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-about-fs-free',
    templateUrl: './about-fs-free.component.html',
    styleUrl: './about.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AboutFsFreeComponent {
  @Input() showTiles = true;

  //@Input() user$: Observable<any>
}
